import React, { useMemo } from 'react';
import * as THREE from 'three';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader';
import { useTargetContext } from '../context/TargetContext';

function SVGShape({ shape, rotation, color }: any) {
  return (
    <mesh rotation={rotation}>
      <meshPhongMaterial
        color={color}
        side={THREE.DoubleSide}
        depthWrite={false}
        transparent={false}
      />
      <shapeGeometry args={[shape]} />
    </mesh>
  );
}

interface ElevatorProps {
  width: number;
  height: number;
  boxSize: number;
  onClick: () => void;
}

const Elevator = ({ width, height, boxSize, onClick }: ElevatorProps) => {
  const { target } = useTargetContext();
  // SVG of elevator
  const elevatorSVG = useMemo(
    () =>
      SVGLoader.prototype.parse(
        `<svg width="163" height="204" viewBox="0 0 163 204" xmlns="http://www.w3.org/2000/svg">
      <path d="M162 163.242L82 203V81L162 43V163.242Z" fill="#A3A3A3" stroke="#282828" stroke-width="2" stroke-linejoin="round"/>
      <path d="M1.66113 163.242L81.6611 203V80.9707L1.66113 43V163.242Z" fill="#666666" stroke="#282828" stroke-width="2" stroke-linejoin="round"/>
      <path d="M82 81L162 42.1435L82 1L2 42.1435L82 81Z" fill="#D2D2D2" stroke="#282828" stroke-width="2" stroke-linejoin="round"/>
      <path d="M105 191L145 170.904V99L105 117.923V191Z" fill="#E9E9E9" stroke="#282828" stroke-width="2" stroke-linejoin="round"/>
      <path d="M127 108L127 180" stroke="#282828" stroke-width="2" stroke-linejoin="round"/>
      </svg>
      `
      ),
    []
  );

  // load SVG shapes
  const svgShapes = useMemo(() => {
    return elevatorSVG.paths.flatMap((g) =>
      g.toShapes(true).map((shape) => ({ shape, color: g.color }))
    );
  }, [elevatorSVG]);

  // load SVG strokes
  const svgStrokes = useMemo(() => {
    return elevatorSVG.paths
      .flatMap((g) => g.subPaths)
      .map((g) =>
        SVGLoader.pointsToStroke(g.getPoints(), {
          strokeColor: '#000000',
          strokeWidth: 3,
          strokeLineJoin: 'round',
          strokeLineCap: '',
          strokeMiterLimit: 0,
        })
      );
  }, [elevatorSVG]);

  return (
    <group
      position={[
        (-height / 2) * boxSize + boxSize * 0.51,
        38,
        (width / 2) * boxSize - boxSize * 1.5,
      ]}
      rotation={[0, Math.PI / 4.05, Math.PI]}
      scale={[0.22, 0.25, 0.22]}
      renderOrder={1}
      onClick={(e) => {
        e.stopPropagation();
        target === 'dev' && console.log('Elevator click');
        onClick();
      }}
    >
      {svgShapes.map((item, i) => (
        <SVGShape key={`elevator-shape-${i}`} {...item} />
      ))}
      {svgStrokes.map((stroke, i) => (
        <mesh key={`elevator-stroke-${i}`} geometry={stroke}>
          <meshBasicMaterial
            attach="material"
            color="#000000"
            side={THREE.DoubleSide}
          />
        </mesh>
      ))}
    </group>
  );
};

export default Elevator;
